import { FC } from "react";
import { useShowReferAFriend } from "~/features/Referral/useShowReferAFriend";
import { TwoPanelTemplate } from "~/OnboardingApp/components";
import {
  Meta,
  LeftRAFSection,
  LeftSection,
  RightRAFSection,
  RightSection,
} from "./components";

const sectionsByBool = {
  raf: {
    left: <LeftRAFSection />,
    right: <RightRAFSection />,
  },
  default: {
    left: <LeftSection />,
    right: <RightSection />,
  },
};

export const WelcomePage: FC = () => {
  const isRAF = useShowReferAFriend();
  const key = isRAF ? "raf" : "default";

  const sections = sectionsByBool[key];

  return (
    <>
      <Meta />
      <TwoPanelTemplate {...sections} />
    </>
  );
};
